<div class="top-bar">
  <p class="texto">
    <img src="assets/svg/icon-soccer.svg" alt="soccer">Envío gratis a todo el Perú
  <img src="assets/svg/icon-soccer.svg" alt="soccer"></p>
</div>
